<template>
  <div>
    <b-card-body class="px-0 pt-1 pb-0">
      <b-row no-gutters class="g-1">
        <template v-for="(job, index) in professionsToShow" >
          <b-col cols="12" lg="6" :key="index" :data-item-index="index">
            <professions-item
              :top="index < 6"
              :index="index + 1"
              :title="job.tit"
              :name="job.name"
              :rank="job.rank"
              :show-rank-bars="showRankBars"
              :inf="job.inf"
              :pdf="job.pdf"
              :plt="job.plt"
              :quantity="job.amt"
              :id="job.id"
              :is-auth="isAuth"
              :language-sid="languageSid"
              :regulared-profession="job.regulated_profession"
            />
          </b-col>
        </template>
      </b-row>
    </b-card-body>
    <b-card-body v-if="isShowMoreVisible" class="p-0">
      <!-- Reveals more items in place, so it is a button, not a link (#20303) -->
      <button
        type="button"
        class="btn-inline-link togglelabel collapsed fs-6 fw-bold"
        :aria-expanded="jobShow ? 'true' : 'false'"
        @click="toggleShowMore()"
      >
        <span class="label">{{ jobShow ? translations[14014] : translations[13645] }}</span>
      </button>
    </b-card-body>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import ProfessionsItem from '@/components/Home/ProfessionsItem.vue';
import { AppModule } from '@/store/modules/app';

const DEFAULT_COUNT_TO_SHOW = 50;

@Component({
  components: {
    ProfessionsItem,
  },
})
export default class ProfessionsList extends Vue {
  @Prop({ default: () => [] }) private items!: any;

  @Prop({ default: false }) isAuth!: boolean;

  @Prop({ default: '' }) languageSid!: string;

  @Prop({ default: false }) showRankBars!: boolean;

  get translations() {
    return AppModule.translation;
  }

  get isShowMoreVisible() {
    return this.items.length > DEFAULT_COUNT_TO_SHOW;
  }

  jobShow = false;

  get professionsToShow() {
    return this.jobShow ? this.items : this.items.slice(0, DEFAULT_COUNT_TO_SHOW);
  }

  async toggleShowMore() {
    this.jobShow = !this.jobShow;
    if (!this.jobShow) return;
    // Keyboard / screen reader users would otherwise stay on the toggle link and
    // have to search backwards for the newly revealed items (#20287).
    await this.$nextTick();
    this.focusFirstNewItem();
  }

  focusFirstNewItem() {
    const col = this.$el.querySelector<HTMLElement>(`[data-item-index="${DEFAULT_COUNT_TO_SHOW}"]`);
    const target = (col?.firstElementChild as HTMLElement | null) || col;
    if (!target) return;
    // `tabindex` is not part of the item's virtual DOM, so Vue never removes it
    // on a later patch; -1 keeps the card out of the Tab order.
    target.tabIndex = -1;
    target.focus();
  }
}
</script>
<style scoped lang="scss"></style>
